import * as L from 'leaflet';
import * as BingLayer from 'leaflet-bing-layer';

const shUrl = '//maptiles.komplett.info/';
const osmAttribution = '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' +
  ', <a href="http://www.eea.europa.eu/data-and-maps/data/eu-dem">eu-dem</a>';
const baseLayer = new L.TileLayer(shUrl + 'snowhow/{z}/{x}/{y}.jpg', {
  attribution: osmAttribution,
  minZoom: 8,
  // errorTileUrl: 'icon/missing_tile.png',
  bounds: [
    [45.18, 6.3],
    [48, 16.15]
  ],
  maxZoom: 17
});
const pistsLayer = new L.TileLayer(shUrl + 'pists/{z}/{x}/{y}.png', {
  attribution: '',
  minZoom: 8,
  errorTileUrl: 'icon/missing_tile.png',
  opacity: 0.4,
  bounds: [
    [46.7768, 10.2832],
    [47.5276, 12.4801]
  ],
  maxZoom: 17
});
const slopeLayer = new L.TileLayer(shUrl + 'snowhowslope/{z}/{x}/{y}.png', {
  attribution: '<a href="http://www.tirol.gv.at/organisation/verwaltungsentwicklung/informationsweiterverwendung/">' +
    'Tirol</a>, <a href="http://www.provinz.bz.it/informatik/">Prov.Bozen</a>, ' +
    '<a href="http://www.vorarlberg.at/lva">Vorarlberg</a>',
  // ' <a href="http://www.eea.europa.eu/data-and-maps/data/eu-dem">eu-dem</a>, '
  opacity: 0.4,
  className: "freerideinfoWarning",
  minZoom: 14,
  maxZoom: 17
});

var basemap_url = "//maps.wien.gv.at/basemap/bmapgrau/normal/google3857/{z}/{y}/{x}.png";
var basemap_at = new L.TileLayer(basemap_url, {
  attribution: "<a href='//www.basemap.at'>basemap.at</a>",
  bounds: [
    [46.358770, 8.782379],
    [49.037872, 17.189532]
  ],
  minZoom: 8,
  maxZoom: 17
});
const bingLayer = new BingLayer("Ag85AiKRnPuJdpi5Hs6PE6eDgWRB0xP-4WcJ0T5-KflZgWw6s4Car5N3L9t5nY7D", {
  minZoom: 8,
  maxZoom: 17
});

export { baseLayer, slopeLayer, pistsLayer, basemap_at, bingLayer }
